import { Box, Button } from "@mui/material"
import { Create } from "./Create"
import { List } from './List'
import { env } from "../../../../core/Env"
import { rqx } from "../../../../core/request/API"
import { useEffect } from "react"

export const Training = ({setup_state, tool_state}) => {
    const { trainingForm, trainingList, loader, totalList, hasMore, page } = setup_state
    const { __SESSION } = tool_state
	
    const handleCreateTraining = async () => {
        try {
            const s = await rqx.get(`<<tool>>/${env()}/setupTraining/read_series_num`, {company_id: __SESSION.data.uaccess[0].company_id})
            if (s) {
                trainingForm.set({...trainingForm.data, open:true, id: '', code: s.series_num, training_name: '', training_date: '', training_start: '', training_end: '', location: '', training_fee: 'free', training_price: '', meeting_link: '', meeting_id: '', meeting_pass: '', confirmation: false, error: false, loader: false, method: 'create', training_type: '', active: true, show_shop: false, date_today: s.date_today})
            }
        } catch (error) {
            console.error(error)
        }
    }

    const readTrainings = async(pageToFetch) => {
        if (pageToFetch === 1) {
            loader.set(true)
        }
        const read = await rqx.get(`<<tool>>/${env()}/setupTraining/read_list`, {company_id: __SESSION.data.uaccess[0].company_id, page: pageToFetch, limit: 10 })
		const d = read.data?.map(v => ({ ...v, training_fees: JSON.parse(v.training_fees) }))
        totalList.set(read.total)
        if (d.length < 10) {
            hasMore.set(false)
        }else{
            hasMore.set(true)
        }
        if (pageToFetch === 1) {
            trainingList.set(d)
        }else{
            trainingList.set((prevData) => [...prevData, ...d])
        }
        page.set(pageToFetch + 1)
        loader.set(false)
    }

    const loadMoreData = () => {
        readTrainings(page.data)
    }

    useEffect(() => {
        readTrainings(1)
        // eslint-disable-next-line
    }, [])
   
    return (
        <Box height="100%" width="100%" display="flex" flexDirection="column" className="overflowY" gap="24px" mt={2}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box fontSize={20} fontWeight={700}>Training List</Box>
                <Button variant="contained" sx={{ fontSize: 14, fontWeight: 400 }} onClick={handleCreateTraining}>Create Training</Button>
            </Box>
            <List loadMoreData={loadMoreData} />
            {
                trainingForm.data.open &&
                    <Create setup_state={setup_state} tool_state={tool_state} readTrainings={readTrainings}/>
            }
        </Box>
    )
}
